import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const auroraOption: Option<CriteriaKey> = {
  name: 'Amazon Aurora',
  description:
    'A fully-managed database service that makes it easy to set up, operate, and scale relational databases in the cloud',
  tags: ['SQL', 'Relational'],
  pros: ['Cost-effective', 'High performance'],
  cons: ['Performance limitations', 'Limited control over infrastructure'],
  documentationLink: 'https://aws.amazon.com/rds/aurora/',
  criteriaScores: {
    availability: { score: { value: 9 } },
    securityAndCompliance: { score: { value: 8 } },
    performanceAndScalability: { score: { value: 8 } },
    dataConsistency: { score: { value: 10 } },
    dataStructure: { score: { value: 10 } },
    costOptimization: { score: { value: 8 } },
    dataPersistence: { score: { value: 10 } },
  },
};
